import { z } from "zod/v4";
export const createCampaignNoteInputSchema = z.object({
    title: z.string().optional().default(""),
    content: z.unknown().optional().default([]),
});
export const updateCampaignNoteInputSchema = z.object({
    title: z.string().optional(),
    content: z.unknown().optional(),
});
